import React, { useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function Navbar() {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const hideOn = ["/login", "/register", "/forgot-password", "/reset-password"];
  if (hideOn.some((path) => location.pathname.startsWith(path))) return null;

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#121829]/95 backdrop-blur-md shadow-lg">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-cyan-500 text-sm font-bold text-white shadow-md">
            AR
          </div>

          <div className="flex flex-col leading-tight">

            <span className="text-xs text-slate-300 italic">
              Make your Dream Now With US ✨
            </span>
          </div>
        </div>

        <nav className="flex items-center gap-3 sm:gap-6">
          <Link
            to="/"
            className="rounded-xl px-3 py-2 text-sm font-medium text-slate-200 transition duration-200 hover:bg-white/10 hover:text-white"
          >
            Home
          </Link>

          <Link
            to="/knowledge"
            className="rounded-xl px-3 py-2 text-sm font-medium text-slate-200 transition duration-200 hover:bg-white/10 hover:text-white"
          >
            Knowledge
          </Link>

          {user && (
            <button
              onClick={handleLogout}
              className="rounded-xl bg-red-500 px-4 py-2 text-sm font-semibold text-white shadow-md transition duration-200 hover:bg-red-600 hover:shadow-lg active:scale-[0.98]"
            >
              Logout
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}